module.exports = __webpack_public_path__ + "img/icon_header_service.a5fdb5e8.svg";